import React from 'react';
import { Panel } from 'react-bootstrap';

import CollegeSummary from './CollegeSummary';
import EducationValidation, { EducationValidationPT } from '../validation/educationValidation';
import { PROGRAM_ADN, statusTypes } from "../config/constants";

const EducationInfoSummary = (props) => {
  const withoutValidation = props.withoutValidation;
  const validationStatus = props.programId === PROGRAM_ADN ? new EducationValidation().getValidationStatus(props) : new EducationValidationPT().getValidationStatus(props);
  const renderColleges = () => {
    if(props.colleges.length === 0) {
      return (
        <div>No colleges</div>
      )
    }

    return props.colleges.map((college) => {
      return (
        <CollegeSummary key={college.id} {...college}/>
      );
    });
  };

  return(
    <Panel header="Educational Information" bsStyle={withoutValidation ? statusTypes.INFO : validationStatus.section.status}>
      {renderColleges()}
    </Panel>
  );
};

export default EducationInfoSummary;